import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const FAQS = [{
  q: '¿Esto es para personas con ansiedad severa?',
  a: 'El protocolo está diseñado para regular el sistema nervioso en momentos de reactividad social aguda. Si bien es una herramienta poderosa basada en neurociencia, no sustituye el tratamiento psiquiátrico para trastornos severos, sino que funciona como un excelente complemento.'
}, {
  q: '¿Cuánto tiempo tarda en funcionar?',
  a: 'El ejercicio físico de estimulación vagal toma exactamente 120 segundos. Los efectos de calma biológica se sienten casi de inmediato al reducir los niveles de cortisol circulante en tu cuerpo.'
}, {
  q: '¿Necesito experiencia en meditación o psicología?',
  a: "Absolutamente no. Esto no es meditación ni requiere 'poner la mente en blanco'. Son ejercicios físicos y biológicos que activan respuestas automáticas en tu cuerpo, independientemente de lo que estés pensando."
}, {
  q: '¿Cómo accedo al protocolo después de comprarlo?',
  a: 'Recibirás un correo electrónico inmediatamente con tus credenciales de acceso a nuestra plataforma privada. Podrás ver los videos y descargar los audios desde tu celular o computadora en cualquier momento.'
}, {
  q: '¿Es un diagnóstico médico?',
  a: 'No. El test y el protocolo son herramientas educativas basadas en neurobiología para el manejo del estrés y la reactividad social. No constituyen un diagnóstico médico ni psicológico.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 bg-navy" data-id="element-29">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8 text-center" data-id="element-31">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-32">
          {FAQS.map((faq, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden" data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-34">
                <span className="font-bold text-offwhite text-lg pr-4" data-id="element-35">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-yellow transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
              </button>
              <AnimatePresence data-id="element-37">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-38">
                    <div className="px-6 pb-6 text-offwhite/70 leading-relaxed" data-id="element-39">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}